import { computed } from 'vue';
import { decodeJwt, getJwtExpiry, getJwtTimeLeftMs, isJwtExpired } from '@/modules/auth/utils/jwt';

export function useJwtInfo(token: string | null) {
  const expiryDate = computed(() => (token ? getJwtExpiry(token) : null));
  const timeLeftMs = computed(() => (token ? getJwtTimeLeftMs(token) : null));
  const expired = computed(() => (token ? isJwtExpired(token, 30) : true)); // 30s Leeway

  // Praktisch für UI: Minuten verbleibend
  const secondsLeft = computed(() => (timeLeftMs.value == null ? null : Math.max(0, Math.floor(timeLeftMs.value / 1000))));
  const minutesLeft = computed(() => (timeLeftMs.value == null ? null : Math.max(0, Math.floor(timeLeftMs.value / 60000))));

  const parsedToken = computed<any>(() => {
    if (!token) return null;
    return decodeJwt(token);
  });

  return { expiryDate, timeLeftMs, secondsLeft, minutesLeft, expired, parsedToken };
}
